import React from 'react';
import { IGenerateButtonProps } from './generateButton.types';
import Spinner from '../../assets/images/spinner.gif';

export function GenerateButton({ isLoading, disabled }: IGenerateButtonProps) {
  return (
    <div className={`generate-container ${disabled === '' ? 'disabled' : ''}`}  >
        <div className='generate-btn'>
            {
                isLoading ? (<img
                    src={Spinner}
                    alt="Loading..."
                    style={{ width: '30px', height: '30px' }}
                  />) : <span className='generate-txt'>Generate</span>
            }
        </div>
    </div>
  )
}